/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createProductRevenueRankingFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type ProductRevenueRanking } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/analytics/products/top-by-revenue
 */
export interface TopByRevenueRequestBuilder extends BaseRequestBuilder<TopByRevenueRequestBuilder> {
    /**
     * Ranks the order lines sold in the period by the revenue they carried, highest first, and returns the leading few. Rows are built from the lines themselves rather than the catalog, so a product discontinued since still shows. There is one row per SKU: if the name on its lines changed during the period, the row carries one of those names. Revenue is the sum of the line subtotals, so it excludes order-level charges and the column will not add up to total revenue. productsOrdered counts units; orderCount and uniqueOrders are the same figure, the number of distinct orders the SKU appeared on. Both date bounds are inclusive. A period with no orders returns an empty array.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ProductRevenueRanking[]>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<TopByRevenueRequestBuilderGetQueryParameters> | undefined) : Promise<ProductRevenueRanking[] | undefined>;
    /**
     * Ranks the order lines sold in the period by the revenue they carried, highest first, and returns the leading few. Rows are built from the lines themselves rather than the catalog, so a product discontinued since still shows. There is one row per SKU: if the name on its lines changed during the period, the row carries one of those names. Revenue is the sum of the line subtotals, so it excludes order-level charges and the column will not add up to total revenue. productsOrdered counts units; orderCount and uniqueOrders are the same figure, the number of distinct orders the SKU appeared on. Both date bounds are inclusive. A period with no orders returns an empty array.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<TopByRevenueRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Ranks the order lines sold in the period by the revenue they carried, highest first, and returns the leading few. Rows are built from the lines themselves rather than the catalog, so a product discontinued since still shows. There is one row per SKU: if the name on its lines changed during the period, the row carries one of those names. Revenue is the sum of the line subtotals, so it excludes order-level charges and the column will not add up to total revenue. productsOrdered counts units; orderCount and uniqueOrders are the same figure, the number of distinct orders the SKU appeared on. Both date bounds are inclusive. A period with no orders returns an empty array.
 */
export interface TopByRevenueRequestBuilderGetQueryParameters {
    /**
     * End of the period, inclusive. Compared against the order date as a full timestamp, so adate with no time stops at midnight; it must not be earlier than the start date.
     */
    endDate?: Date;
    /**
     * How many rows to return, taken from the top of the ranking. Defaults to 10; there is nopaging, so raise this rather than trying to page past the cut-off.
     */
    limit?: number;
    /**
     * Start of the period, inclusive. Compared against the order date as a full timestamp.
     */
    startDate?: Date;
}
/**
 * Uri template for the request builder.
 */
export const TopByRevenueRequestBuilderUriTemplate = "{+baseurl}/api/analytics/products/top-by-revenue?endDate={endDate}&limit={limit}&startDate={startDate}";
/**
 * Metadata for all the requests in the request builder.
 */
export const TopByRevenueRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: TopByRevenueRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createProductRevenueRankingFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
